import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';

import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import Header from 'reservations/base/components/Header';
import useIsDesktop from 'reservations/base/hooks/useIsDesktop';
import { WHITE } from 'reservations/brand/constants';

export const TextOnlyLayout = () => {
  const restaurantName = useRestaurantName();
  const theme = useTheme();
  const isDesktop = useIsDesktop();

  return (
    <Grid
      data-testid="text-only-layout"
      sx={{
        display: 'grid',
        width: '100%',
        alignItems: 'end',
        justifyContent: 'start',
        paddingBottom: '0px',
        marginLeft: isDesktop ? 'inherit' : '16px'
      }}
    >
      <Header
        text={restaurantName}
        color={WHITE}
        fontSize={(theme.typography.h2.fontSize as string) ?? '42px'}
      />
    </Grid>
  );
};
